import React from 'react'
import MobileMenu from './components/MobileMenu';
import Viewport from './components/Viewport';
import api from '../api'
import { toast } from 'sonner';

import { useState } from 'react';
import {Link, useNavigate} from "react-router-dom"
import { AiOutlineMenu } from "react-icons/ai";
import { BsEye } from "react-icons/bs";
import spinner from '../images/Spinnerblack.svg'

import PageFooter from './components/PageFooter'


const Signin = () => {

  const { width } = Viewport();
  const [inactiveMobileNav, activeMobileNav] = useState(false)
  const breakpoint = 558;

  const navigate = useNavigate();

  //toggle password view
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  //signin form submit-------------------------------
  const [signinValues, setsigninValues] = useState({
    email: "",
    password: "",
  });

  const [isLoadingBtn, updateisLoadingBtn] = useState(null)
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const signinSubmit = async (e) =>{
    e.preventDefault();
    updateisLoadingBtn(true)
    setIsButtonDisabled(true)

    try {
        const signInResp =  await api.post('/api/signin', {...signinValues})
        const signIndata = signInResp.data;

        if(signIndata.errMsg){
            toast.error(signIndata.errMsg);
            window.scroll(0, 0)
            updateisLoadingBtn(false)
            setIsButtonDisabled(false)
        }else{
            if(signIndata.adminSuccessMsg){
                updateisLoadingBtn(false)
                sessionStorage.setItem('role', 'admin')
                navigate('/admin/dashboard');
            }else{
                updateisLoadingBtn(false)
                sessionStorage.setItem('role', 'user')
                navigate('/user/dashboard');
            }
        }

    }catch (error) {
        console.log(error)
        updateisLoadingBtn(false)
        setIsButtonDisabled(false)
    }
  }


  return (
    <div className="relative overflow-hidden flex flex-col justify-start items-center bg-mainBackColor text-white w-full p-[1rem] min-h-screen ">

        <MobileMenu closeMobileMenu = {() => {activeMobileNav(false) }} translateAction = {inactiveMobileNav ? `translate-y-[0px]` : `translate-y-[-1500px]`} />

        {<nav className="relative flex justify-between items-center min-h-[4rem] w-full md:w-[80%]">

          <Link to = '/' className="relative flex justify-start items-center h-full">
            <span className="font-logo font-[700] text-[18px] tracking-tight text-white">Zenit<span className="text-userDashPurple">chain</span></span>
          </Link>

          {width < breakpoint ? <button className="flex" onClick={() => activeMobileNav(true)}>
              <AiOutlineMenu className='text-white font-[500] text-[24px]'/>
          </button> : ''}

          <div className="hidden justify-between items-center sm:flex">
                <ul className="flex space-x-10">
                  <li className="text-white font-[600] text-[15.5px]"> <Link to = "/Signin">Trade</Link> </li>
                  <li className="text-white font-[600] text-[15.5px]"> <Link to = "/about">About</Link> </li>
                  <li className="text-white font-[600] text-[15.5px]"> <Link to = "/airdrops">Airdrops</Link> </li>
                </ul>
          </div>

        </nav>}

        <div className='relative py-[7rem] min-h-[10rem] w-full flex flex-col justify-start items-center space-y-[2rem] md:w-[80%]'>

            <div className='relative'>
                <h1 className='text-white text-[22px] font-[550] pb-[0.50rem]'>Welcome To ZenitChain</h1>
                <p className='text-[#ACACB5] pb-5'>Log into your account or <Link to = '/signup' className='text-primaryGreen'>Sign Up</Link> to create an account. </p>
            </div>

            <form action="" className='w-full flex flex-col justify-center items-center' onSubmit={(e) => signinSubmit(e)}>
                  <div className='relative w-full flex flex-col justify-center items-center space-y-4'>

                      <div className='relative w-full flex flex-col justify-start items-center space-y-2 '>

                            <div className='w-full flex justify-between sm:w-[450px]'>
                                <label htmlFor="email" className='text-[15px] text-left text-white font-[550]'>Email/Username</label>
                            </div>

                            <input type="text" name='email' className='bg-[#0e0e2c] px-2 border-[#1e1e4a] border-[1px] rounded-[5px] w-full h-[45px] text-white text-[16px] sm:w-[450px] focus:outline-none focus:border-primaryGreen' onChange={(e)=> setsigninValues({...signinValues, [e.target.name]:e.target.value})} />

                            <div className='w-full flex justify-between sm:w-[450px]'>
                                <label htmlFor="password" className='text-[15px] text-left text-white font-[550]'>Password</label>
                                <button type="button" onClick={togglePasswordVisibility} className='flex items-center justify-end text-[14px] text-[#ACACB5]'><BsEye className='text-[#ACACB5] mr-[5px] text-[16px]'/> {showPassword ? 'Hide' : 'Show'} </button>
                            </div>

                            <input
                                type={showPassword ? 'text' : 'password'}
                                name='password'
                                className='bg-[#0e0e2c] px-2 border-[#1e1e4a] border-[1px] rounded-[5px] w-full h-[45px] text-white text-[16px] sm:w-[450px] focus:outline-none focus:border-primaryGreen'
                                onChange={(e)=> setsigninValues({...signinValues, [e.target.name]:e.target.value})}
                            />

                            <div className='w-full flex justify-end sm:w-[450px] '>
                                <Link className='text-[14px] text-[#ACACB5]' to = "/forgotpassword">Forgot password?</Link>
                            </div>
                      </div>

                      <button type='submit' disabled = {isButtonDisabled} className='bg-primaryGreen text-mainBackColor font-bold rounded-md flex justify-center items-center text-center w-full h-[50px] transition-all sm:w-[450px] hover:bg-primaryGreen/90 glow-green'>
                          {isLoadingBtn ? <img src={spinner} className='w-[50px] h-[50px]' alt='loading' /> : <p>Sign In</p>}
                      </button>
                  </div>
              </form>

        </div>

        <PageFooter />

    </div>
  )
}

export default Signin
